<script setup lang="ts"></script>

<template>
  <div class="">
    <header>Header public</header>
    <slot />
  </div>
</template>
